




















import vue from "vue";
import {
  SessionDetails,
  TerratalkLiveActionNames,
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";
import { VUEX_ROOT_ACTION_NAMES } from "@tt-app/constants";

interface Methods {
  logout: () => void;
  overrideSessionOwner: () => void;
}

interface Computed {
  activeDeviceUuid?: string;
  deviceUuid?: string;
  sessionActiveOnOtherDevice: boolean;
  sessionDetails?: SessionDetails;
}

export default vue.extend<Record<any, any>, Methods, Computed, Record<any, any>>({
  name: "TerratalkLiveSessionOwnerAlert",

  methods: {
    logout() {
      this.$store.dispatch(`${VUEX_ROOT_ACTION_NAMES.LOGOUT_REQUEST}`);
    },

    overrideSessionOwner() {
      this.$store.dispatch(`${TerratalkLiveNamespace}/${TerratalkLiveActionNames.TAKE_OWNERSHIP}`);
    }
  },

  computed: {
    activeDeviceUuid() {
      return this.sessionDetails?.activeDeviceUuid;
    },

    deviceUuid() {
      return this.$store.state.deviceUuid;
    },

    sessionActiveOnOtherDevice() {
      if (!this.deviceUuid || !this.activeDeviceUuid) {
        return false;
      }

      return this.deviceUuid !== this.activeDeviceUuid;
    },

    sessionDetails() {
      return this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.ACTIVE_SESSION_DETAILS}`
      ];
    }
  }
});
